<template lang="pug">
v-row
  v-col(cols="6")
    v-subheader Выберите необходимый курс и тему
    select-course-subject(
      v-model="selectedUnit"
      :get-courses-method="getCourses"
      withoutLesson
      showFaq
    )
  v-col
    v-card.sdo-card(v-if="isUnit")
      v-list-item.pt-2
        v-list-item-content
          v-list-item-subtitle.caption Тема
          .text-h6 {{ selectedUnit.title }}

      .d-flex.pr-4
        v-btn.ml-auto(
          color="primary"
          text
          :icon="$vuetify.breakpoint.smAndDown"
          :outlined="$vuetify.breakpoint.smAndDown"
          @click="openAddQuestion(selectedUnit)"
        )
          span(v-if="!$vuetify.breakpoint.smAndDown") Добавить вопрос
          v-icon(:right="!$vuetify.breakpoint.smAndDown") mdi-plus

      v-list.px-4
        v-list-item(v-for="item in selectedUnit.faq" :key="item.id" link).mb-4
          v-list-item-icon.mr-4.mt-3
            tooltip-wrap(
              :text="STATUSES.draft === item.status ? 'Принята' : item.statusData.text"
            )
              v-icon(
                :color="STATUSES.draft === item.status ? 'primary' : item.statusData.color"
              ) mdi-message-question-outline
          v-list-item-content
            .text-body-1 {{ item.question }}
            .text-body-2.grey--text.text-darken-2
              v-icon(small color="primary").mr-1 mdi-message-processing-outline
              span.caption Ответ:
              span.secondary--text.ml-2 {{ item.answer }}
          v-list-item-icon.mt-2(v-if="STATUSES.request === item.status")
            v-menu
              template(#activator="{ on }")
                v-btn(
                  icon
                  v-on="on"
                ): v-icon mdi-menu
              v-sheet(min-width="250" dark).secondary.pa-3
                v-list-item.secondary.lighten-1.mb-2(
                  @click="openAddQuestion(selectedUnit, item)"
                )
                  v-list-item-action.mr-4: v-icon() mdi-pencil
                  v-list-item-content.text-body-2.py-0: strong Редактировать
                v-list-item.secondary.lighten-1(
                  @click="deleteQuestion(item, selectedUnit)"
                )
                  v-list-item-action.mr-4: v-icon() mdi-delete
                  v-list-item-content.text-body-2.py-0: strong Удалить
    portal(to="addQuestion.dialog" v-slot="{ close, attrs }")
      v-sheet.sdo-card
        v-list-item
          v-list-item-content
            .text-h6 {{ attrs.faq.id ? 'Редактирование вопроса' : 'Добавление вопроса'}}
          v-list-item-action: v-btn(icon @click="close"): v-icon mdi-close
        .px-4.mb-4
          api-form(
            v-model="form"
            :fields="fields"
            :successCallback="(data) => success(data, attrs.faq, attrs.unit)"
            :method="(data) => save(data, attrs.unit, attrs.faq)"
          )
</template>
<script>
import Unit from '@/models/list/Unit';
import UnitFaq from '@/models/list/UnitFaq';
import SelectCourseSubject from '../../components/SelectCourseSubject.vue';

const STATUSES = {
  request: 1,
  canceled: 2,
  draft: 3,
  active: 4,
};

export default {
  components: {
    SelectCourseSubject,
  },
  data() {
    return {
      STATUSES,
      selectedUnit: null,
      form: {},
    };
  },
  computed: {
    fields() {
      return [
        {
          text: 'Текст вопроса',
          value: 'question',
          rules: 'required',
          component: 'v-text-field',
          component_attrs: {
            filled: true,
            rounded: true,
          },
        },
        {
          text: 'Текст ответа',
          value: 'answer',
          rules: 'required',
          component: 'v-text-field',
          component_attrs: {
            filled: true,
            rounded: true,
          },
        },
      ];
    },
    isUnit() {
      return this.selectedUnit instanceof Unit;
    },
  },
  watch: {
    selectedUnit(val) {
      if (this.isUnit) {
        val.getFaq({ 'search[owner_id]': this.$user.data.id });
      }
    },
  },
  methods: {
    openAddQuestion(unit, faq = {}) {
      this.form = faq;
      this.$modals.show('dialog-portal', {
        inputValue: 'addQuestion',
        unit,
        faq,
      });
    },
    async deleteQuestion(faq, unit) {
      this.$modals.show('confirm-controller', {
        dialogProps: {
          width: 800,
        },
        method: async () => {
          await faq.delete().then(() => {
            this.$toasted.success('Успех');
            const index = unit.faq.findIndex(({ id }) => id === faq.id);
            unit.faq.splice(index, 1);
            this.$modals.close();
          });
        },
      });
    },
    success({ data }, faq, unit) {
      if (faq.id) {
        const moduleItem = unit.faq.find((i) => i.id === faq.id);
        Object.assign(moduleItem, data);
        this.$toasted.success('Успех');
      } else unit.faq.push(new UnitFaq({ ...data.data, answer: { answer: this.form.answer } }));
      this.$modals.close();
    },
    save({ data }, unit, faq) {
      const payload = {
        question: {
          ...faq.id ? {} : { status: 1 },
          question: data.question,
          course_unit_id: unit.id,
        },
        answer: {
          answer: data.answer,
        },
      };
      if (faq.id) {
        const noAssign = true;
        return faq.update({ data: payload }, noAssign);
      }
      return this.$api.unitFaq.create(payload);
    },
    getCourses() {
      return this.$api.courses.index({
        'search[teacher]': this.$user.data.id,
        expand: 'course_units_count',
      });
    },
  },
};
</script>
